import { isArray } from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import logoMakerTracker from '@fiverr-private/variations_display/src/service/tracker';
import { EVENTS, EVENT_TYPES } from '@fiverr-private/variations_display/src/service/tracker/constants';
import { app_name } from '../../../../configuration/config';
import { EXPERIMENTS } from '../../../shared/constants/experiments';
import { isAllocated } from '../../../shared/utils/experimentService';

export const initializeLogoMakerTracker = (props) => {
    if (isArray(props.listings)) {
        const [listings] = props.listings;
        const { context: { showLMBannerInSubCPage, isLMBannerInSearchAllowed } } = listings;
        const { abTests = {} } = getContext();
        const showLMBannerInSearchPage = isLMBannerInSearchAllowed && isAllocated(EXPERIMENTS.SPIDERS_BANNER_MPI_SEARCH, abTests);

        if (showLMBannerInSubCPage || showLMBannerInSearchPage) {
            const { logoMakerTrackingProps } = props.tracking;
            logoMakerTracker.initialize({ appName: app_name, EVENTS, EVENT_TYPES, MIXPANEL_CONTEXT: logoMakerTrackingProps });
        }
    }
};
